import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import NoPlanIcon from "@components/Icons/NoPlanIcon";

const useStyles = makeStyles()({
  root: {
    height: 500,
  },
});

const StyledNoPlanIcon = withStyles(NoPlanIcon, {
  root: {
    height: "71px",
    width: "71px",
    alignSelf: "center",
  },
});

type NoTemplateViewProps = {
  searchString: string | null;
};

const NoTemplateView: React.FC<NoTemplateViewProps> = ({ searchString }) => {
  const { classes } = useStyles();
  const content = searchString
    ? `No template name matches "${searchString}"`
    : "No templates created";

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      className={classes.root}
    >
      <StyledNoPlanIcon />
      <Typography
        variant="subtitle1"
        color="textSecondary"
        style={{ textAlign: "center" }}
      >
        {content}
      </Typography>
    </Box>
  );
};

export default NoTemplateView;
